import request from '@/utils/request';
const userUrl = "/userinfo";
// 获取列表
export const listRole = (query) => {
  return request({
    url: userUrl + '/system/role/list',
    method: 'get',
    params: query,
  });
};
// 新增角色
export function addRole(query) {
    return request({
        url: userUrl + '/system/role',
        method: 'post',
        data: query,
    });
}
// 编辑角色
export function editRole(query) {
    return request({
        url: userUrl + '/system/role',
        method: 'put',
        data: query,
    });
}
// 角色状态修改
export function changeRoleStatus(roleId, status) {
    const data = {
      roleId,
      status,
    };
    return request({
      url: userUrl + '/system/role/changeStatus',
      method: 'put',
      data,
    });
  }
// 删除角色
export function delRole(roleId) {
  return request({
    url: userUrl + '/system/role/' + roleId,
    method: 'delete',
  });
}
// 查询菜单下拉树结构
export function treeselect() {
    return request({
      url: userUrl + '/system/menu/treeselect',
      method: 'get',
    });
  }
  // 根据角色ID查询菜单下拉树结构
export function roleMenuTreeselect(roleId) {
    return request({
      url: userUrl + '/system/menu/roleMenuTreeselect/' + roleId,
      method: 'get',
    });
  }
